import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()(() => ({
  title: {
    textAlign: 'center',
  },
  triggerMessage: {
    marginBottom: 10,
  },
  triggerCounter: {
    fontSize: 22,
    fontWeight: 500,
  },
  triggerPopupContent: {
    display: 'flex',
    flexDirection: 'column',
    maxWidth: 500,
    alignItems: 'center',
  },
  triggerPopupButton: {
    width: 200,
  },
}))

export default useStyles
